import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 22,
  class: "text-brand-red"
}

import { computed, defineAsyncComponent } from 'vue';

import AddressField from 'SharedComponents/Fields/Types/AddressField.vue';
import CheckboxField from 'SharedComponents/Fields/Types/CheckboxField.vue';
import DateField from 'SharedComponents/Fields/Types/DateField.vue';
import FileField from 'SharedComponents/Fields/Types/FileField.vue';
import FileSetField from 'SharedComponents/Fields/Types/FileSetField.vue';
import GeolocationField from 'SharedComponents/Fields/Types/Geolocation.vue';
import LabelField from 'SharedComponents/Fields/Types/LabelField.vue';
import NumberField from 'SharedComponents/Fields/Types/NumberField.vue';
import ObjectField from 'SharedComponents/Fields/Types/ObjectField.vue';
import PictureField from 'SharedComponents/Fields/Types/Picture.vue';
import PictureGalleryField from 'SharedComponents/Fields/Types/PictureGallery.vue';
import SelectField from 'SharedComponents/Fields/Types/SelectField.vue';
import SeparatorField from 'SharedComponents/Fields/Types/Separator.vue';
import TextField from 'SharedComponents/Fields/Types/TextField.vue';
import TextareaField from 'SharedComponents/Fields/Types/TextareaField.vue';
import TreeField from 'SharedComponents/Fields/Types/Tree.vue';
import TreeSelectField from 'SharedComponents/Fields/Types/TreeSelectField.vue';
import VideoField from 'SharedComponents/Fields/Types/Video.vue';
import WysiwygField from 'SharedComponents/Fields/Types/Wysiwyg.vue';
import FileSampleField from 'SharedComponents/Fields/ViewMode/FileSample.vue';
import {
  BaseFieldEmits,
  ValuedFieldProps,
  defaultValuedProps,
} from 'SharedComponents/Fields/composables/useBaseFieldProps';
import useFieldProp from 'SharedComponents/Fields/composables/useFieldProp';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { Field, FieldValue } from 'SharedDir/declarations/fields';
import { WithRelations } from 'SharedDir/declarations/shared';

type FieldComponentProps = ValuedFieldProps & {
  field: WithRelations<Field>;
  /** Только у таблицы: какие строки покрасить из-за конфликтов. Остальные типы игнорируют. */
  highlightedRowIndexes?: number[];
} & PropValue<FieldValue | null>;

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FieldComponent' },
  __name: 'FieldComponent',
  props: /*@__PURE__*/_mergeDefaults({
    readonly: { type: Boolean },
    disable: { type: Boolean },
    required: { type: Boolean },
    useWrapper: { type: Boolean },
    skipValidation: { type: Boolean },
    errorMessage: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    field: {},
    highlightedRowIndexes: {},
    modelValue: {}
  }, {
  ...defaultValuedProps,
  highlightedRowIndexes: () => [],
}),
  emits: ["update:modelValue", "reveal-history"],
  setup(__props: any, { emit: __emit }) {

const FixedTableField = process.env.CLIENT
  ? defineAsyncComponent(() => import('SharedComponents/Fields/Types/FixedTableField.vue'))
  : undefined;

const DynamicTableField = process.env.CLIENT
  ? defineAsyncComponent(() => import('SharedComponents/Fields/Types/DynamicTableField.vue'))
  : undefined;



const props = __props;

const emit = __emit;

const { innerValue, emitValue } = useValue(props, emit, {
  transform: (value) => value ?? { value: null },
});

const showField = computed(() => !props.field?.params?.isHidden);

const {
  itIsTextField,
  itIsTextareaField,
  itIsNumberField,
  itIsDateField,
  itIsCheckboxField,
  itIsSelectField,
  itIsFileField,
  itIsFileSetField,
  itIsAddressField,
  itIsLabelField,
  itIsFixedTableField,
  itIsDynamicTableField,
  itIsWysiwygField,
  itIsPictureField,
  itIsPictureGalleryField,
  itIsVideoField,
  itIsGeolocationField,
  itIsTreeSelectField,
  itIsTreeField,
  itIsFileSampleField,
  itIsSeparatorField,
  itIsObjectField,
} = useFieldProp(props);

return (_ctx: any,_cache: any) => {
  const _component_q_no_ssr = _resolveComponent("q-no-ssr")!

  return (_openBlock(), _createBlock(_component_q_no_ssr, null, {
    default: _withCtx(() => [
      (showField.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(itIsTextField))
              ? (_openBlock(), _createBlock(TextField, {
                  key: 0,
                  modelValue: _unref(innerValue),
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
                    _unref(emitValue)
                  ],
                  class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
                  label: _ctx.label,
                  required: _ctx.required,
                  disable: _ctx.disable,
                  "skip-validation": _ctx.skipValidation,
                  "error-message": _ctx.errorMessage,
                  readonly: _ctx.readonly,
                  "show-history": _ctx.showHistory,
                  history: _ctx.history,
                  params: _ctx.field.params,
                  suffix: _ctx.field.measureUnit,
                  regexp: _ctx.field.validationRegpexp,
                  "regexp-message": _ctx.field.validationRegpexpErrorMessage,
                  onRevealHistory: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                }, null, 8, ["modelValue", "class", "label", "required", "disable", "skip-validation", "error-message", "readonly", "show-history", "history", "params", "suffix", "regexp", "regexp-message", "onUpdate:modelValue"]))
              : (_unref(itIsTextareaField))
                ? (_openBlock(), _createBlock(TextareaField, {
                    key: 1,
                    modelValue: _unref(innerValue),
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
                      _unref(emitValue)
                    ],
                    class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
                    label: _ctx.label,
                    required: _ctx.required,
                    disable: _ctx.disable,
                    "skip-validation": _ctx.skipValidation,
                    "error-message": _ctx.errorMessage,
                    readonly: _ctx.readonly,
                    "show-history": _ctx.showHistory,
                    history: _ctx.history,
                    params: _ctx.field.params,
                    regexp: _ctx.field.validationRegpexp,
                    "regexp-message": _ctx.field.validationRegpexpErrorMessage,
                    onRevealHistory: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                  }, null, 8, ["modelValue", "class", "label", "required", "disable", "skip-validation", "error-message", "readonly", "show-history", "history", "params", "regexp", "regexp-message", "onUpdate:modelValue"]))
                : (_unref(itIsNumberField))
                  ? (_openBlock(), _createBlock(NumberField, {
                      key: 2,
                      modelValue: _unref(innerValue),
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
                        _unref(emitValue)
                      ],
                      class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
                      label: _ctx.label,
                      required: _ctx.required,
                      disable: _ctx.disable,
                      "skip-validation": _ctx.skipValidation,
                      "error-message": _ctx.errorMessage,
                      readonly: _ctx.readonly,
                      "show-history": _ctx.showHistory,
                      history: _ctx.history,
                      params: _ctx.field.params,
                      suffix: _ctx.field.measureUnit,
                      regexp: _ctx.field.validationRegpexp,
                      "regexp-message": _ctx.field.validationRegpexpErrorMessage,
                      onRevealHistory: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                    }, null, 8, ["modelValue", "class", "label", "required", "disable", "skip-validation", "error-message", "readonly", "show-history", "history", "params", "suffix", "regexp", "regexp-message", "onUpdate:modelValue"]))
                  : (_unref(itIsDateField))
                    ? (_openBlock(), _createBlock(DateField, {
                        key: 3,
                        modelValue: _unref(innerValue),
                        "onUpdate:modelValue": [
                          _cache[6] || (_cache[6] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
                          _unref(emitValue)
                        ],
                        class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
                        label: _ctx.label,
                        required: _ctx.required,
                        disable: _ctx.disable,
                        "skip-validation": _ctx.skipValidation,
                        "error-message": _ctx.errorMessage,
                        readonly: _ctx.readonly,
                        "show-history": _ctx.showHistory,
                        history: _ctx.history,
                        params: _ctx.field.params,
                        onRevealHistory: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                      }, null, 8, ["modelValue", "class", "label", "required", "disable", "skip-validation", "error-message", "readonly", "show-history", "history", "params", "onUpdate:modelValue"]))
                    : (_unref(itIsCheckboxField))
                      ? (_openBlock(), _createBlock(CheckboxField, {
                          key: 4,
                          modelValue: _unref(innerValue),
                          "onUpdate:modelValue": [
                            _cache[8] || (_cache[8] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
                            _unref(emitValue)
                          ],
                          class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
                          label: _ctx.label,
                          required: _ctx.required,
                          disable: _ctx.disable,
                          "skip-validation": _ctx.skipValidation,
                          "error-message": _ctx.errorMessage,
                          readonly: _ctx.readonly,
                          "show-history": _ctx.showHistory,
                          history: _ctx.history,
                          params: _ctx.field.params,
                          onRevealHistory: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                        }, null, 8, ["modelValue", "class", "label", "required", "disable", "skip-validation", "error-message", "readonly", "show-history", "history", "params", "onUpdate:modelValue"]))
                      : (_unref(itIsSelectField))
                        ? (_openBlock(), _createBlock(SelectField, {
                            key: 5,
                            modelValue: _unref(innerValue),
                            "onUpdate:modelValue": [
                              _cache[10] || (_cache[10] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
                              _unref(emitValue)
                            ],
                            class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
                            label: _ctx.label,
                            required: _ctx.required,
                            disable: _ctx.disable,
                            "skip-validation": _ctx.skipValidation,
                            "error-message": _ctx.errorMessage,
                            readonly: _ctx.readonly,
                            "show-history": _ctx.showHistory,
                            history: _ctx.history,
                            params: _ctx.field.params,
                            onRevealHistory: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                          }, null, 8, ["modelValue", "class", "label", "required", "disable", "skip-validation", "error-message", "readonly", "show-history", "history", "params", "onUpdate:modelValue"]))
                        : (_unref(itIsFileField))
                          ? (_openBlock(), _createBlock(FileField, {
                              key: 6,
                              modelValue: _unref(innerValue),
                              "onUpdate:modelValue": [
                                _cache[12] || (_cache[12] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
                                _unref(emitValue)
                              ],
                              class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
                              label: _ctx.label,
                              required: _ctx.required,
                              disable: _ctx.disable,
                              "skip-validation": _ctx.skipValidation,
                              "error-message": _ctx.errorMessage,
                              readonly: _ctx.readonly,
                              "show-history": _ctx.showHistory,
                              history: _ctx.history,
                              params: _ctx.field.params,
                              onRevealHistory: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                            }, null, 8, ["modelValue", "class", "label", "required", "disable", "skip-validation", "error-message", "readonly", "show-history", "history", "params", "onUpdate:modelValue"]))
                          : (_unref(itIsFileSetField))
                            ? (_openBlock(), _createBlock(FileSetField, {
                                key: 7,
                                modelValue: _unref(innerValue),
                                "onUpdate:modelValue": [
                                  _cache[14] || (_cache[14] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
                                  _unref(emitValue)
                                ],
                                class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
                                label: _ctx.label,
                                required: _ctx.required,
                                disable: _ctx.disable,
                                "skip-validation": _ctx.skipValidation,
                                "error-message": _ctx.errorMessage,
                                readonly: _ctx.readonly,
                                "show-history": _ctx.showHistory,
                                history: _ctx.history,
                                params: _ctx.field.params,
                                onRevealHistory: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                              }, null, 8, ["modelValue", "class", "label", "required", "disable", "skip-validation", "error-message", "readonly", "show-history", "history", "params", "onUpdate:modelValue"]))
                            : (_unref(itIsAddressField))
                              ? (_openBlock(), _createBlock(AddressField, {
                                  key: 8,
                                  modelValue: _unref(innerValue),
                                  "onUpdate:modelValue": [
                                    _cache[16] || (_cache[16] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
                                    _unref(emitValue)
                                  ],
                                  class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
                                  label: _ctx.label,
                                  required: _ctx.required,
                                  disable: _ctx.disable,
                                  "skip-validation": _ctx.skipValidation,
                                  "error-message": _ctx.errorMessage,
                                  readonly: _ctx.readonly,
                                  "show-history": _ctx.showHistory,
                                  history: _ctx.history,
                                  params: _ctx.field.params,
                                  onRevealHistory: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                                }, null, 8, ["modelValue", "class", "label", "required", "disable", "skip-validation", "error-message", "readonly", "show-history", "history", "params", "onUpdate:modelValue"]))
                              : (_unref(itIsFixedTableField))
                                ? (_openBlock(), _createBlock(_unref(FixedTableField), {
                                    key: 9,
                                    modelValue: _unref(innerValue),
                                    "onUpdate:modelValue": [
                                      _cache[18] || (_cache[18] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
                                      _unref(emitValue)
                                    ],
                                    class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
                                    label: _ctx.label,
                                    required: _ctx.required,
                                    disable: _ctx.disable,
                                    "skip-validation": _ctx.skipValidation,
                                    "error-message": _ctx.errorMessage,
                                    readonly: _ctx.readonly,
                                    "show-history": _ctx.showHistory,
                                    history: _ctx.history,
                                    params: _ctx.field.params,
                                    onRevealHistory: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                                  }, null, 8, ["modelValue", "class", "label", "required", "disable", "skip-validation", "error-message", "readonly", "show-history", "history", "params", "onUpdate:modelValue"]))
                                : (_unref(itIsDynamicTableField))
                                  ? (_openBlock(), _createBlock(_unref(DynamicTableField), {
                                      key: 10,
                                      modelValue: _unref(innerValue),
                                      "onUpdate:modelValue": [
                                        _cache[20] || (_cache[20] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
                                        _unref(emitValue)
                                      ],
                                      class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
                                      label: _ctx.label,
                                      required: _ctx.required,
                                      disable: _ctx.disable,
                                      "skip-validation": _ctx.skipValidation,
                                      "error-message": _ctx.errorMessage,
                                      readonly: _ctx.readonly,
                                      "show-history": _ctx.showHistory,
                                      history: _ctx.history,
                                      params: _ctx.field.params,
                                      "highlighted-row-indexes": _ctx.highlightedRowIndexes,
                                      onRevealHistory: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                                    }, null, 8, ["modelValue", "class", "label", "required", "disable", "skip-validation", "error-message", "readonly", "show-history", "history", "params", "highlighted-row-indexes", "onUpdate:modelValue"]))
                                  : (_unref(itIsTreeSelectField))
                                    ? (_openBlock(), _createBlock(TreeSelectField, {
                                        key: 11,
                                        modelValue: _unref(innerValue),
                                        "onUpdate:modelValue": [
                                          _cache[22] || (_cache[22] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
                                          _unref(emitValue)
                                        ],
                                        class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
                                        label: _ctx.label,
                                        required: _ctx.required,
                                        disable: _ctx.disable,
                                        "skip-validation": _ctx.skipValidation,
                                        "error-message": _ctx.errorMessage,
                                        readonly: _ctx.readonly,
                                        "show-history": _ctx.showHistory,
                                        history: _ctx.history,
                                        params: _ctx.field.params,
                                        onRevealHistory: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                                      }, null, 8, ["modelValue", "class", "label", "required", "disable", "skip-validation", "error-message", "readonly", "show-history", "history", "params", "onUpdate:modelValue"]))
                                    : (_unref(itIsObjectField))
                                      ? (_openBlock(), _createBlock(ObjectField, {
                                          key: 12,
                                          modelValue: _unref(innerValue),
                                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
                                          class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
                                          label: _ctx.label,
                                          "show-history": _ctx.showHistory,
                                          history: _ctx.history,
                                          params: _ctx.field.params,
                                          onRevealHistory: _cache[25] || (_cache[25] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                                        }, null, 8, ["modelValue", "class", "label", "show-history", "history", "params"]))
                                      : (_unref(itIsLabelField))
                                        ? (_openBlock(), _createBlock(LabelField, {
                                            key: 13,
                                            label: "",
                                            params: _ctx.field.params
                                          }, null, 8, ["params"]))
                                        : (_unref(itIsTreeField))
                                          ? (_openBlock(), _createBlock(TreeField, {
                                              key: 14,
                                              label: "",
                                              params: _ctx.field.params
                                            }, null, 8, ["params"]))
                                          : (_unref(itIsFileSampleField))
                                            ? (_openBlock(), _createBlock(FileSampleField, {
                                                key: 15,
                                                label: "",
                                                params: _ctx.field.params
                                              }, null, 8, ["params"]))
                                            : (_unref(itIsSeparatorField))
                                              ? (_openBlock(), _createBlock(SeparatorField, {
                                                  key: 16,
                                                  label: "",
                                                  params: _ctx.field.params
                                                }, null, 8, ["params"]))
                                              : (_unref(itIsWysiwygField))
                                                ? (_openBlock(), _createBlock(WysiwygField, {
                                                    key: 17,
                                                    label: "",
                                                    params: _ctx.field.params
                                                  }, null, 8, ["params"]))
                                                : (_unref(itIsPictureField))
                                                  ? (_openBlock(), _createBlock(PictureField, {
                                                      key: 18,
                                                      label: "",
                                                      params: _ctx.field.params
                                                    }, null, 8, ["params"]))
                                                  : (_unref(itIsPictureGalleryField))
                                                    ? (_openBlock(), _createBlock(PictureGalleryField, {
                                                        key: 19,
                                                        label: "",
                                                        params: _ctx.field.params
                                                      }, null, 8, ["params"]))
                                                    : (_unref(itIsVideoField))
                                                      ? (_openBlock(), _createBlock(VideoField, {
                                                          key: 20,
                                                          label: "",
                                                          params: _ctx.field.params
                                                        }, null, 8, ["params"]))
                                                      : (_unref(itIsGeolocationField))
                                                        ? (_openBlock(), _createBlock(GeolocationField, {
                                                            key: 21,
                                                            label: "",
                                                            params: _ctx.field.params
                                                          }, null, 8, ["params"]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_1, " Отображение данного вида компонент (" + _toDisplayString(_ctx.field.fieldType?.name) + ") еще не реализовано ", 1))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})